import { render } from "./DefaultText.vue?vue&type=template&id=aa8734a0"
import script from "./DefaultText.vue?vue&type=script&lang=js"
export * from "./DefaultText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__